'use client';
import { Link } from '@mui/material';
import { useState } from 'react';
import { COLORS } from '../../constants';

export const TextEllipsis = ({ children, maxLength }: { children: string; maxLength?: number }) => {
  const [messageShrinked, setMessageShrinked] = useState(true);
  const max = maxLength || 80;
  return (
    <>
      {children.length > max && messageShrinked ? `${children.slice(0, max)}...` : children}
      {children.length > max && (
        <>
          {' '}
          <Link
            component="button"
            type="button"
            underline="none"
            aria-expanded={!messageShrinked}
            sx={{
              color: `${COLORS.text.main} !important`,
              font: 'inherit',
              fontSize: 'inherit',
              verticalAlign: 'baseline',
              cursor: 'pointer',
            }}
            onClick={() => setMessageShrinked((current) => !current)}
          >
            (Ver {messageShrinked ? 'más' : 'menos'})
          </Link>
        </>
      )}
    </>
  );
};
